import React from 'react';
import DevicesList from "fit/pages/strength/DevicesList";

const DevicesRoute=()=>{
    return <DevicesList/>
}

export default DevicesRoute;